import React, { ReactElement } from 'react';
import { Button, Col, Grid, Modal, Row, Text } from 'rsuite';

import ResponsiveModal from 'src/components/ResponsiveModal';
import IconIndicator from 'src/components/user-feedback/IconIndicator';

interface ConfirmationModalProps {
  loading: boolean;
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
  permitType: string;
}

export const ConfirmationModal = ({
  loading,
  open,
  onAccept,
  onClose,
  permitType,
}: ConfirmationModalProps): ReactElement => {
  return (
    <ResponsiveModal
      isOpen={open}
      onClose={onClose}
      ariaLabel="update-account-confirmation"
    >
      <Modal.Header className="ph-8 pt-8">
        <Modal.Title
          as="h2"
          className="mt-8"
        >
          Confirmation of Personal Information Update
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '10px' }}>
        <Grid fluid>
          <Row>
            <Col xs={24}>
              <Text className="mb-12">
                Please note that any details updated here will apply to all{' '}
                {permitType} associated with this account. If you do not wish to
                update all {permitType} with these details, please hit Cancel.
              </Text>
              <Text>
                This process may take a bit of time depending on how many{' '}
                {permitType} are associated with your account.
              </Text>
            </Col>
          </Row>
          {loading && (
            <Row>
              <Col xs={24}>
                <IconIndicator />
              </Col>
            </Row>
          )}
        </Grid>
      </Modal.Body>
      <Modal.Footer style={{ padding: '10px', textAlign: 'left' }}>
        <Grid fluid>
          <Row className="mb-16">
            <Col xs={24}>
              <Button
                onClick={onAccept}
                className="btn-primary sm-100-percent"
                disabled={loading}
                data-cy="update-account-confirmation-confirm"
              >
                Confirm
              </Button>
              <Button
                onClick={onClose}
                className="btn-tertiary sm-100-percent"
                data-cy="update-account-confirmation-cancel"
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Grid>
      </Modal.Footer>
    </ResponsiveModal>
  );
};
